export const GET_FS_SOURCES = 'GET_FUNDING_SOURCE';

export const frequencyEnumsConvert = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    ENTIRE_TERM: 'ENTIRE_TERM',
};

export const frequencyList = [
    { title: 'Weekly', value: frequencyEnumsConvert.WEEKLY, count: true },
    { title: 'Monthly', value: frequencyEnumsConvert.MONTHLY, count: true },
    { title: 'Entire Term', value: frequencyEnumsConvert.ENTIRE_TERM },
];

export const clientRelationshipEnums = {
    SELF: 'SELF',
    SPOUSE: 'SPOUSE',
    CHILD: 'CHILD',
    OTHER: 'OTHER',
};
export const clientRelationship = [
    { title: 'Self', value: clientRelationshipEnums.SELF },
    { title: 'Spouse', value: clientRelationshipEnums.SPOUSE },
    { title: 'Child', value: clientRelationshipEnums.CHILD },
    { title: 'Other', value: clientRelationshipEnums.OTHER },
];

/** Add/Edit Payer "Fill from" dropdown group headers. */
export const insuredFillGroups = {
    CLIENT: 'Client',
    CLIENT_CONTACT: 'Client Contacts',
};
